module.exports = __webpack_public_path__ + "static/media/facebook.03cc5a11.svg";